/**
 * Task HH: Senvia 助手 (platform AI support chat), AI 设计助手 (website, shop's own key), AI data import ("从旧系统搬家"),
 * Platform admin → 平台 AI. One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["hh.sa.button","Senvia assistant","Senvia 助手"],
  ["hh.sa.unavailable","Not available yet","暂未开放"],
  ["hh.sa.unavailableLong","The Senvia assistant will be switched on soon. Until then, “Contact a person” reaches the Senvia team.","Senvia 助手即将开放。在此之前，可以点「联系人工客服」联系 Senvia 团队。"],
  ["hh.sa.intro","Hi! Ask me how to do anything in Senvia POS. I can't see or change your shop's data.","您好！Senvia POS 的任何操作问题都可以问我。我看不到也不会修改店里的数据。"],
  ["hh.sa.placeholder","Ask a question, e.g. how do I add a service?","输入问题，例如：怎么新增服务？"],
  ["hh.sa.send","Send","发送"],
  ["hh.sa.thinking","Thinking…","思考中…"],
  ["hh.sa.human","Contact a person","联系人工客服"],
  ["hh.sa.humanTitle","Contact Senvia support","联系 Senvia 人工客服"],
  ["hh.sa.humanNote","What do you need help with?","需要什么帮助？"],
  ["hh.sa.humanPhone","Phone (optional)","电话（可选）"],
  ["hh.sa.humanSend","Send to the Senvia team","发送给 Senvia 团队"],
  ["hh.sa.humanDone","Sent. The Senvia team will reply by e-mail or phone within one working day.","已发送。Senvia 团队会在一个工作日内通过邮件或电话回复您。"],
  ["hh.sa.open","Open","打开"],
  ["hh.sa.remaining","{n} questions left today","今天还可以问 {n} 次"],
  ["hh.sa.new","New chat","新对话"],
  ["hh.sa.close","Close","关闭"],
  ["hh.sa.clarify","Answer the questions above so I can give you the exact steps.","回答上面的问题，我才能给您准确的步骤。"],
  ["hh.sa.suggest1","How do I add a service?","怎么新增服务？"],
  ["hh.sa.suggest2","How do I move my customers from my old POS?","怎么把旧系统的顾客搬过来？"],
  ["hh.sa.suggest3","Help","帮帮我"],
  // (Public assistant) visitors who are not signed in (sign-in / sign-up pages)
  ["hh.pa.publicTitle","Visitors who are not signed in","未登录访客"],
  ["hh.pa.publicIntro","The Senvia assistant on senviapos.com and the sign-in / sign-up pages answers questions about Senvia only (pre-sales). Uses the platform key; counted separately as \"Visitors (not signed in)\".","senviapos.com 官网以及登录 / 注册页上的 Senvia 助手，只回答关于 Senvia 的问题（售前咨询）。使用平台密钥，用量单独记为「未登录访客」。"],
  ["hh.pa.publicEnabled","Answer visitors who are not signed in","为未登录访客回答问题"],
  ["hh.pa.publicDailyCap","All visitors: questions per day","所有访客：每天问题总数"],
  ["hh.pa.publicPerIp","Per visitor (IP): questions per day","每位访客（IP）：每天问题数"],
  ["hh.pa.anonymous","Visitors (not signed in)","未登录访客"],
  ["hh.pa.anonymousToday","today {n}","今天 {n}"],
  ["pa.intro","Hi! Ask me anything about Senvia POS — features, prices, how it works or how to get started. I only answer questions about Senvia.","您好！关于 Senvia POS 的功能、价格、使用方式或如何开始，都可以问我。我只回答关于 Senvia 的问题。"],
  ["pa.placeholder","Ask about Senvia, e.g. how much does it cost?","问关于 Senvia 的问题，例如：多少钱？"],
  ["pa.suggest1","How much does Senvia cost?","Senvia 多少钱？"],
  ["pa.suggest2","What can Senvia do for my salon?","Senvia 能为我的店做什么？"],
  ["pa.suggest3","Can I move my data from my old system?","可以把旧系统的资料搬过来吗？"],
  ["pa.human","For a person, e-mail the Senvia team at {email} — or sign in and use the assistant inside the system.","需要真人协助，请发邮件给 Senvia 团队：{email}；或登录后在系统里使用助手。"],
  ["pa.unavailable","The Senvia assistant is not available right now. Please e-mail {email}.","Senvia 助手暂未开放，请发邮件到 {email}。"],
  ["hh.ds.title","AI design assistant","AI 设计助手"],
  ["hh.ds.intro","Tell it how your website should look — style, colours, sections and texts. It only changes the website draft; you review every change and publish yourself.","告诉它您想要的官网样子——风格、颜色、栏目和文字。它只修改官网草稿；每项修改都要您确认，发布仍由您自己操作。"],
  ["hh.ds.byo","Uses your own AI key (Settings → AI). Billed by your AI provider.","使用您自己的 AI 密钥（设置 → AI），费用由您的 AI 服务商收取。"],
  ["hh.ds.connect","Connect your own AI key first to use the design assistant.","请先连接您自己的 AI 密钥才能使用设计助手。"],
  ["hh.ds.goSettings","Open Settings → AI","打开 设置 → AI"],
  ["hh.ds.askOwner","Ask the owner to connect an AI key.","请店主先连接 AI 密钥。"],
  ["hh.ds.placeholder","e.g. Soft pink and elegant, add a FAQ section, warmer welcome text","例如：改成柔和的粉色、优雅风格，加一个常见问题栏目，欢迎语更亲切"],
  ["hh.ds.send","Ask","发送"],
  ["hh.ds.apply","Apply to draft","应用到草稿"],
  ["hh.ds.discard","Discard","放弃"],
  ["hh.ds.undo","Undo","撤销"],
  ["hh.ds.applied","Applied to the draft","已应用到草稿"],
  ["hh.ds.discarded","Discarded","已放弃"],
  ["hh.ds.undone","Undone","已撤销"],
  ["hh.ds.scope","Website design only — questions about the system go to the Senvia assistant.","只负责官网设计——系统操作问题请问 Senvia 助手。"],
  ["hh.ds.preview","Changes","修改内容"],
  ["hh.ds.saveFirst","Save your own changes first, then apply the AI's changes to the draft.","请先保存您自己的修改，再把 AI 的修改应用到草稿。"],
  ["hh.im.title","Import from your old system","从旧系统搬家"],
  ["hh.im.intro","Upload a CSV, Excel (.xlsx / .xls) or Google Sheets export — or paste a table. Senvia's AI matches the columns; you check everything before anything is saved.","上传 CSV、Excel（.xlsx / .xls）或 Google 表格导出的文件，或直接粘贴表格。Senvia 的 AI 自动对应每一栏；保存前您可以检查所有内容。"],
  ["hh.im.step.upload","Upload","上传"],
  ["hh.im.step.map","Match columns","对应栏位"],
  ["hh.im.step.preview","Check","检查"],
  ["hh.im.step.done","Done","完成"],
  ["hh.im.kind","What is in this file?","这个文件是什么资料？"],
  ["hh.im.kind.auto","Detect automatically","自动识别"],
  ["hh.im.kind.customers","Customers (incl. packages, stored value, points)","顾客（含配套、储值、积分）"],
  ["hh.im.kind.services","Services & prices","服务与价格"],
  ["hh.im.kind.products","Products & stock","产品与库存"],
  ["hh.im.kind.staff","Staff list","员工名单"],
  ["hh.im.kind.appointments","Upcoming appointments","未来预约"],
  ["hh.im.file","Choose a file (CSV, .xlsx, .xls)","选择文件（CSV、.xlsx、.xls）"],
  ["hh.im.paste","…or paste a table (copied from Excel / Google Sheets)","…或粘贴表格（从 Excel / Google 表格复制）"],
  ["hh.im.pasteGo","Use the pasted table","使用粘贴的表格"],
  ["hh.im.templates","Templates","模板"],
  ["hh.im.privacy","Privacy: only the column headers and about 20 sample rows are sent to the AI. The full file is processed by Senvia's own system.","隐私：只有表头和约 20 行样本会发送给 AI；完整文件由 Senvia 自己的系统处理。"],
  ["hh.im.aiMatch","Match columns with AI","用 AI 对应栏位"],
  ["hh.im.aiMatching","The AI is matching the columns…","AI 正在对应栏位…"],
  ["hh.im.aiDone","The AI matched {n} of {total} columns ({model}).","AI 对应了 {total} 栏中的 {n} 栏（{model}）。"],
  ["hh.im.autoDone","Matched {n} of {total} columns by their names.","已按栏名对应 {total} 栏中的 {n} 栏。"],
  ["hh.im.aiOff","AI matching is not available right now — columns were matched by their names. Check them below.","AI 对应暂不可用——已按栏名自动对应，请在下方检查。"],
  ["hh.im.detected","Detected: {kind}","识别为：{kind}"],
  ["hh.im.col","Column","栏"],
  ["hh.im.sample","Examples","示例"],
  ["hh.im.field","Import as","导入为"],
  ["hh.im.confidence","Sure?","把握"],
  ["hh.im.notImport","Don't import","不导入"],
  ["hh.im.unrecognised","Not recognised, set to “Don't import”: {list}. Choose a field if you need them.","无法识别，默认「不导入」：{list}。如需导入请手动选择栏位。"],
  ["hh.im.colItem","column {n} “{h}”","第 {n} 栏「{h}」"],
  ["hh.im.missing","Still needed: {fields}","还需要对应：{fields}"],
  ["hh.im.check","Check the data","检查资料"],
  ["hh.im.rowsWith","Rows {rows}: {text}","第 {rows} 行：{text}"],
  ["hh.im.more"," and {n} more"," 等共 {n} 行"],
  ["hh.im.problemsTitle","Rows with problems","有问题的行"],
  ["hh.im.warningsTitle","Notes","提示"],
  ["hh.im.noProblems","No problems found.","没有发现问题。"],
  ["hh.im.fix","Fix","修改"],
  ["hh.im.skip","Skip row","跳过此行"],
  ["hh.im.unskip","Import this row","恢复导入此行"],
  ["hh.im.save","Save","保存"],
  ["hh.im.row","Row","行"],
  ["hh.im.recheck","Check again","重新检查"],
  ["hh.im.summary","Summary","汇总"],
  ["hh.im.c.create","New","新增"],
  ["hh.im.c.merge","Update existing","更新已有"],
  ["hh.im.c.skip","Skipped","跳过"],
  ["hh.im.c.duplicate","Duplicate","重复"],
  ["hh.im.c.error","Problems","有问题"],
  ["hh.im.start","Import {n} rows","导入 {n} 行"],
  ["hh.im.startConfirm","The import runs in the background. You can keep working and undo it within 7 days.","导入会在后台进行，您可以继续工作，7 天内可以撤销。"],
  ["hh.im.running","Importing in the background… {done} / {total}","正在后台导入… {done} / {total}"],
  ["hh.im.result","Created {created}, updated {updated}, skipped {skipped}, errors {errors}","新增 {created}，更新 {updated}，跳过 {skipped}，错误 {errors}"],
  ["hh.im.errorsCsv","Download the error report (with row numbers)","下载错误报告（含行号）"],
  ["hh.im.undo","Undo this import","撤销这次导入"],
  ["hh.im.undoUntil","Can be undone until {date}.","{date} 前可以撤销。"],
  ["hh.im.undoConfirm","Everything this import created is removed again (balances included). Records used since then block the undo.","删除这次导入新增的所有资料（含余额）。导入后已被使用的资料会阻止撤销。"],
  ["hh.im.undone","Import undone","已撤销这次导入"],
  ["hh.im.another","Import another file","导入另一个文件"],
  ["hh.im.history","Earlier imports","以前的导入"],
  ["hh.im.nav","Import data","导入数据"],
  ["hh.im.setupIntro","Already have customers, services or stock in another POS or in Excel? Bring them over in a few minutes — or skip and do it later in Settings → Import data.","在其他收银系统或 Excel 里已有顾客、服务或库存？几分钟就能搬过来——也可以先跳过，之后在 设置 → 导入数据 操作。"],
  ["hh.im.setupOpen","Start importing","开始搬家"],
  ["hh.im.balancesNote","Packages and stored value become customer balances with the note “导入自旧系统”.","配套和储值会变成顾客余额，备注「导入自旧系统」。"],
  ["hh.im.options","Options","选项"],
  ["hh.f.name","Name","名称"],
  ["hh.f.category","Category","分类"],
  ["hh.f.price","Price","价格"],
  ["hh.f.duration","Duration (min)","时长（分钟）"],
  ["hh.f.description","Description","说明"],
  ["hh.f.sku","Code / SKU","编号 / 货号"],
  ["hh.f.online","Online booking","网上预约"],
  ["hh.f.barcode","Barcode","条码"],
  ["hh.f.cost","Cost","成本"],
  ["hh.f.stock_qty","Stock on hand","现有库存"],
  ["hh.f.reorder_point","Minimum stock","最低库存"],
  ["hh.f.phone","Phone","电话"],
  ["hh.f.email","E-mail","邮箱"],
  ["hh.f.job_title","Position","职位"],
  ["hh.f.level","Level","级别"],
  ["hh.f.bookable","Takes bookings","可预约"],
  ["hh.f.customer_name","Customer name","顾客姓名"],
  ["hh.f.customer_phone","Customer phone","顾客电话"],
  ["hh.f.date","Date","日期"],
  ["hh.f.time","Time","时间"],
  ["hh.f.service","Service","服务"],
  ["hh.f.staff","Staff","员工"],
  ["hh.f.notes","Notes","备注"],
  ["hh.pa.nav","Platform AI","平台 AI"],
  ["hh.pa.intro","Senvia's own Anthropic key powers the Senvia assistant (support chat) and the AI column matching of imports. Shops' own keys are only used for website design.","Senvia 自己的 Anthropic 密钥用于 Senvia 助手（客服对话）和导入的 AI 栏位对应。店家自己的密钥只用于官网设计。"],
  ["hh.pa.key","Platform key (ANTHROPIC_API_KEY_PLATFORM)","平台密钥（ANTHROPIC_API_KEY_PLATFORM）"],
  ["hh.pa.keyOk","Configured","已配置"],
  ["hh.pa.keyMissing","Missing — the assistant shows “暂未开放”","未配置——助手显示「暂未开放」"],
  ["hh.pa.enabled","Assistant and AI import switched on","启用助手和 AI 导入"],
  ["hh.pa.chatModel","Support chat model","客服对话模型"],
  ["hh.pa.importModel","Import matching model","导入对应模型"],
  ["hh.pa.default","Default ({m})","默认（{m}）"],
  ["hh.pa.dailyCap","Messages per shop per day","每店每日消息上限"],
  ["hh.pa.monthlyCap","Messages per shop per month","每店每月消息上限"],
  ["hh.pa.perMinute","Messages per user per minute","每人每分钟消息上限"],
  ["hh.pa.maxTokens","Max tokens per reply","每次回复最多 token"],
  ["hh.pa.importCap","AI column matches per shop per day","每店每日 AI 栏位对应次数"],
  ["hh.pa.save","Save","保存"],
  ["hh.pa.saved","Saved","已保存"],
  ["hh.pa.usage","Usage by shop","各店用量"],
  ["hh.pa.month","Month","月份"],
  ["hh.pa.shop","Shop","店铺"],
  ["hh.pa.messages","Messages","消息"],
  ["hh.pa.imports","AI imports","AI 导入"],
  ["hh.pa.tokens","Tokens in / out / cached","Token 输入 / 输出 / 缓存"],
  ["hh.pa.cost","Est. cost (USD)","估计费用（美元）"],
  ["hh.pa.caps","Caps day / month","上限 日 / 月"],
  ["hh.pa.capsEdit","Caps","上限"],
  ["hh.pa.capDefault","default","默认"],
  ["hh.pa.total","Total","合计"],
  ["hh.pa.noUsage","No usage this month.","本月没有用量。"],
  ["hh.leads.kind","Type","类型"],
  ["hh.leads.support","Support","支持"],
  ["hh.leads.all","All","全部"],
  ["ts.leads.kind.support","Support (Senvia assistant)","支持（Senvia 助手）"],
] as const;

export type HhKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<HhKey, string>;

export const taskHH = { en: col(1), zh: col(2), ms: col(1) };
